var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewResource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M20 6v6m3-3h-6m-4.5-4a4 4 0 11-8 0 4 4 0 018 0z",
    stroke: "#476FF2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDE5VjE3QzE2IDE1LjkzOTEgMTUuNTc4NiAxNC45MjE3IDE0LjgyODQgMTQuMTcxNkMxNC4wNzgzIDEzLjQyMTQgMTMuMDYwOSAxMyAxMiAxM0g1QzMuOTM5MTMgMTMgMi45MjE3MiAxMy40MjE0IDIuMTcxNTcgMTQuMTcxNkMxLjQyMTQzIDE0LjkyMTcgMSAxNS45MzkxIDEgMTdWMTlNMjAgNlYxMk0yMyA5SDE3TTEyLjUgNUMxMi41IDcuMjA5MTQgMTAuNzA5MSA5IDguNSA5QzYuMjkwODYgOSA0LjUgNy4yMDkxNCA0LjUgNUM0LjUgMi43OTA4NiA2LjI5MDg2IDEgOC41IDFDMTAuNzA5MSAxIDEyLjUgMi43OTA4NiAxMi41IDVaIiBzdHJva2U9IiM0NzZGRjIiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgNewResource as ReactComponent };